<template>
  <div class="stock-dashboard-list">
    <table class="overview-table">
      <thead>
        <tr>
          <th>{{ i18n.t('/StockDashboard/Table/Name') }}</th>
          <th>{{ i18n.t('/StockDashboard/Table/Specs') }}</th>
          <th>{{ i18n.t('/StockDashboard/Table/Status') }}</th>
          <th>{{ i18n.t('/StockDashboard/Table/Location') }}</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="stockCars.length">
          <tr
            v-for="stockCar in stockCars"
            :key="stockCar.Id"
            data-qa="stockcar-row"
            class="js-track-click"
            data-action="select-stock-car"
            @click="selectStockCarNew(stockCar, $event)"
          >
            <td>
              <strong data-qa="stockcar-name">
                {{ stockCar.Configuration.ModelName }}
                {{ stockCar.Configuration.TrimlineName }}
              </strong>
              <br />
              {{ stockCar.Configuration.CatalogCarName }} <br />
              {{ i18n.n(stockCar.Configuration.Price.Incl, 'currency') }}
              <br />{{ stockCar.Metadata.LastUpdatedOn }}
              <br />
              <span
                data-qa="stockcar-overview-komnumber"
                class="stockcar-overview-komnumber table__meta-data"
              >
                {{ i18n.t('/StockDashboard/Table/Komnummer') }}
                {{ stockCar.CommissionNumber }}<br />
                {{ stockCar.StockCarDetails?.UnloadDate }}
                <!-- TODO CST-2982 fix unloadDate -->
              </span>
            </td>
            <td>
              {{ stockCar.Configuration.Color.Name }}<br />
              {{ stockCar.Configuration.Interior.Upholstery.Name }}
              {{ stockCar.Configuration.Interior.UpholsteryColor.Name }}<br />
              {{ stockCar.Configuration.Rim.Name }}<br />

              <span class="table__meta-data">{{ stockCar.Configuration.LicensePlate }}</span>
              <span v-if="stockCar.Configuration.Vin" class="table__meta-data">
                | {{ i18n.t('/StockDashboard/Detail/Vin') }} {{ stockCar.Configuration.Vin }}</span
              >
            </td>
            <td data-qa="stockcar-status">
              {{ translatedReservationStatus(stockCar) }}
              <span class="tooltip">
                <span>{{ i18n.t('/StockDashboard/Table/Information') }}:</span>
                <app-tooltip
                  :title="i18n.t('/StockDashboard/ReservationStatus/Title')"
                  data-qa="stockcar-reservation-info"
                  class="stock-status-tooltip"
                  large
                >
                  <stock-reservation-status-new :stock-car="stockCar" />
                </app-tooltip>
              </span>
            </td>
            <td>{{ stockCar.StockCarDetails.Establishment.DealerId }}</td>
          </tr>
        </template>
        <tr v-if="!isLoading && !stockCars.length">
          <td colspan="4">{{ i18n.t('/StockDashboard/Table/NoCarsFound') }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import StoreConnector from '@/helpers/StoreConnector'
import ReservationStatus from '@/helpers/enums/reservationStatus'
import AppTooltip from '@/components/generic/presentational/molecules/appTooltip/AppTooltip.vue'
import StockReservationStatusNew from '@/components/generic/presentational/organisms/stockDashboardNew/StockReservationStatusNew.vue'
import ReservationStatusNew from '@/helpers/enums/reservationStatusNew'

const PAGE_SIZE = 3

export default {
  components: {
    StockReservationStatusNew,
    AppTooltip,
  },
  props: {
    reservationStatuses: {
      type: Array,
      default: null,
    },
  },
  emits: ['selectStockCarNew'],
  data() {
    return {
      isLoading: false,
      stockCars: [],
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      currentPage: 1,
      ReservationStatus,
    }
  },
  computed: {
    shouldLoadMore() {
      return !this.isLoading && PAGE_SIZE * this.currentPage <= this.stockCars.length
    },
    filterReserved() {
      return this.reservationStatuses.some((x) => x.startsWith(ReservationStatus.unavailable))
    },
  },
  created() {
    StoreConnector.get('stockcarsNew/stockcars', (data) => {
      this.stockCars = data
    })
    StoreConnector.get('stockcarsNew/isLoading', (data) => {
      this.isLoading = data
    })
  },
  methods: {
    translatedReservationStatus(stockCar) {
      if (!stockCar || !stockCar.Reservation || !stockCar.Reservation.Status) {
        return this.i18n.t('/StockDashboard/ReservationStatus/Unknown')
      }

      const statusEntry = Object.values(ReservationStatusNew).find(
        (status) => status.value === stockCar.Reservation.Status
      )

      return statusEntry ? this.i18n.t(statusEntry.labelKey) : stockCar.Reservation.Status
    },
    loadMore() {
      StoreConnector.dispatch('stockcarsNew/updateCurrentPage')
    },
    selectStockCarNew(stockCar, event) {
      if (event.target.closest('.tooltip')) return
      if (event.target.closest('button[data-action="close"]')) return
      this.$emit('selectStockCarNew', stockCar)
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip {
  display: flex;
  align-items: center;
}

table {
  margin-bottom: 1em;
}

.stock-dashboard-list {
  margin-bottom: 1em;
  .overview-table {
    td:nth-child(3),
    th:nth-child(3) {
      width: 16rem;
    }
  }
}
</style>
